<template>
  <div class="business-customer">
    <p id="required">* - {{ $t('required') }}</p>
    <fieldset aria-labelledby="formName">
      <VeeForm @submit="forward()" v-slot="{ errors }">
        <error-container v-if="Object.keys(errors).length > 0" :errors="errors"></error-container>
        <div class="small-form">
          <!-- company name -->
          <Field
            name="company"
            rules="required|checkSpecial"
            v-model="company"
            :validateOnBlur="false"
            :validateOnChange="false"
            :validateOnInput="false"
            :validateOnModelUpdate="false"
          >
            <template #default="{ field, errors }">
              <div class="input-container">
                <label for="company" class="input-container__label"
                  >{{ $t("Company's name") }} <span class="required" :aria-label="$t('required_field')">*</span></label
                >
                <input type="text" class="input-container__input" id="company" v-bind="field" />
                <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
              </div>
            </template>
          </Field>
          <!-- company registration number -->
          <Field
            name="registrationNumber"
            rules="required|checkSpecial"
            v-model="companyRegistrationNumber"
            :validateOnBlur="false"
            :validateOnChange="false"
            :validateOnInput="false"
            :validateOnModelUpdate="false"
          >
            <template #default="{ field, errors }">
              <div class="input-container">
                <label for="registrationNumber" class="input-container__label"
                  >{{ $t('Registration number') }}
                  <span class="required" :aria-label="$t('required_field')">*</span></label
                >
                <input type="text" class="input-container__input" id="registrationNumber" v-bind="field" />
                <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
              </div>
            </template>
          </Field>
          <!-- name of representative -->
          <Field
            name="fullName"
            rules="required|checkSpecial"
            v-model="name"
            :validateOnBlur="false"
            :validateOnChange="false"
            :validateOnInput="false"
            :validateOnModelUpdate="false"
          >
            <template #default="{ field, errors }">
              <div class="input-container">
                <label for="fullName" class="input-container__label"
                  >{{ $t("Representative's name and surname") }}
                  <span class="required" :aria-label="$t('required_field')">*</span></label
                >
                <input type="text" class="input-container__input" id="fullName" v-bind="field" />
                <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
              </div>
            </template>
          </Field>
          <!-- personal code of representative -->
          <Field
            name="idCode"
            rules="min:5|required|checkSpecial"
            v-model="id"
            :validateOnBlur="false"
            :validateOnChange="false"
            :validateOnInput="false"
            :validateOnModelUpdate="false"
          >
            <template #default="{ field, errors }">
              <div class="input-container">
                <label for="email" class="input-container__label"
                  >{{ $t("Representative's personal identity code") }}
                  <span class="required" :aria-label="$t('required_field')">*</span></label
                >
                <input type="text" class="input-container__input" id="email" v-bind="field" />
                <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
              </div>
            </template>
          </Field>
          <!-- EE document type -->
          <div
            style="margin-bottom: 2.4rem"
            v-if="
              appCountry == 'EE' &&
              (appointmentType == 'new_client' ||
                appointmentType == 'account_opening' ||
                appointmentType == 'internetbank_user_rights_changes') &&
              branchType == 'video'
            "
          >
            <Field
              name="documentType"
              rules="required|checkSpecial"
              v-model="docType"
              :validateOnBlur="false"
              :validateOnChange="false"
              :validateOnInput="false"
              :validateOnModelUpdate="false"
            >
              <template #default="{ field, errors }">
                <div class="input-container" style="margin-bottom: 3.3rem">
                  <label for="documentType" class="input-container__label" style="margin-bottom: 1.9rem"
                    >{{ $t('document_type_business') }}
                    <span class="required" :aria-label="$t('required_field')">*</span></label
                  >
                  <div
                    v-for="(document, index) in documentList"
                    :key="index"
                    class="d-flex align-items-center radio-button-margin--small"
                    :class="{ 'radio-button-margin--none': index + 1 == documentList.length }"
                  >
                    <input
                      class="custom-radio"
                      type="radio"
                      name="docType"
                      v-bind="field"
                      :id="document.value"
                      :value="document.value"
                    />
                    <label class="custom-radio-label" :for="document.value">{{ $t(document.name) }}</label>
                  </div>
                  <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                </div>
              </template>
            </Field>
            <Field
              name="documentNumber"
              rules="required|checkSpecial|checkDocumentNumber:@documentType"
              v-model="docNumber"
              :validateOnBlur="false"
              :validateOnChange="false"
              :validateOnInput="false"
              :validateOnModelUpdate="false"
            >
              <template #default="{ field, errors }">
                <div class="input-container">
                  <label for="documentNumber" class="input-container__label"
                    >{{ $t('document_number_business') }}
                    <span class="required" :aria-label="$t('required_field')">*</span></label
                  >
                  <input type="text" class="input-container__input" id="documentNumber" v-bind="field" />
                  <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                </div>
              </template>
            </Field>
          </div>
          <!-- email -->
          <Field
            name="email"
            rules="required|email|checkSpecial"
            v-model="mail"
            :validateOnBlur="false"
            :validateOnChange="false"
            :validateOnInput="false"
            :validateOnModelUpdate="false"
          >
            <template #default="{ field, errors }">
              <div class="input-container">
                <label for="email" class="input-container__label"
                  >{{ $t('E-mail') }} <span class="required" :aria-label="$t('required_field')">*</span></label
                >
                <input type="text" class="input-container__input" id="email" v-bind="field" />
                <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
              </div>
            </template>
          </Field>
          <!-- contact number -->
          <div class="input-container">
            <label for="phonePrefix" class="input-container__label visually-hidden"
              >{{ $t('international_telephone_code') }}
              <span class="required" :aria-label="$t('required_field')">*</span></label
            >
            <label for="number" class="input-container__label"
              >{{ $t('Phone number') }} <span class="required" :aria-label="$t('required_field')">*</span></label
            >
            <div class="d-inline-flex w-100">
              <div class="dropdown__container--small">
                <select class="dropdown dropdown__container--small" id="phonePrefix" v-model="phonePrefix">
                  <option v-for="(code, index) in countryCodeList" :key="index" :value="code.dial_code"
                    >{{ code.code }} +{{ code.dial_code }}</option
                  >
                </select>
              </div>
              <Field
                name="number"
                rules="required|numeric|checkSpecial"
                v-model="phone"
                :validateOnBlur="false"
                :validateOnChange="false"
                :validateOnInput="false"
                :validateOnModelUpdate="false"
              >
                <template #default="{ field, errors }">
                  <div>
                    <input type="text" class="input-container__input w-100" id="number" v-bind="field" />
                    <p class="input-container__error" v-if="errors[0]">{{ errors[0] }}</p>
                  </div>
                </template>
              </Field>
            </div>
          </div>
        </div>
        <i18n-t keypath="Terms text" tag="p" class="terms" id="privacyPolicyText">
          <template #X>
            <a :href="termsLink" target="_blank" class="link" aria-labelledby="privacyPolicyText">{{
              $t('Privacy policy')
            }}</a>
          </template>
        </i18n-t>
        <div class="button__wrapper button__wrapper--margin-top-small">
          <button class="button button--secondary" type="button" @click="goBack()">{{ $t('Back') }}</button>
          <button class="button button--primary" type="submit">{{ $t('Continue') }}</button>
        </div>
      </VeeForm>
    </fieldset>
  </div>
</template>

<script>
import { getCountryURL } from '../utils/countryConfig'
import { mapState, mapActions } from 'pinia'
import { useBookingStore, usePersonalStore } from '../store'
import CountryCodesSortedByCode from '../utils/CountryCodes_SortedByCode'
import ErrorContainer from './ErrorContainer.vue'
import { Form, Field } from 'vee-validate'
import '../vee-validate'
import { I18nT } from 'vue-i18n'

export default {
  name: 'PrivateCustomerInfo',
  data() {
    return {
      countryCodeList: null,
      errorList: {},
      termsLink: '',
      documentList: [
        { name: 'id_card', value: 'ID-card' },
        { name: 'estonian_passport', value: 'Estonian Passport' },
        { name: 'residence_permit_card', value: 'Residence permit card' },
      ],
    }
  },
  components: {
    ErrorContainer,
    VeeForm: Form,
    Field,
    I18nT,
  },
  created() {
    this.countryCodeList = CountryCodesSortedByCode
  },
  mounted() {
    this.termsLink = getCountryURL(this.appCountry, this.appLang, 'terms') || getCountryURL('all', 'terms', 'default')
    if (this.countryCode == '') {
      if (this.appCountry == 'LT') {
        this.setCountryCode('370')
      } else if (this.appCountry == 'EE') {
        this.setCountryCode('372')
      } else {
        this.setCountryCode('371')
      }
    }
  },
  computed: {
    ...mapState(useBookingStore, ['appCountry', 'appLang', 'appointmentType', 'branchType']),
    ...mapState(usePersonalStore, [
      'companyName',
      'registrationNumber',
      'fullName',
      'idCode',
      'email',
      'number',
      'countryCode',
      'documentType',
      'documentNumber',
    ]),
    company: {
      get() {
        return this.companyName
      },
      set(value) {
        this.setCompanyName(value)
      },
    },
    companyRegistrationNumber: {
      get() {
        return this.registrationNumber
      },
      set(value) {
        this.setRegistrationNumber(value)
      },
    },
    name: {
      get() {
        return this.fullName
      },
      set(value) {
        this.setFullName(value)
      },
    },
    id: {
      get() {
        return this.idCode
      },
      set(value) {
        this.setIdCode(value)
      },
    },
    mail: {
      get() {
        return this.email
      },
      set(value) {
        this.setEmail(value)
      },
    },
    phonePrefix: {
      get() {
        return this.countryCode
      },
      set(value) {
        this.setCountryCode(value)
      },
    },
    phone: {
      get() {
        return this.number
      },
      set(value) {
        this.setNumber(value)
      },
    },
    docType: {
      get() {
        return this.documentType
      },
      set(value) {
        this.setDocumentType(value)
      },
    },
    docNumber: {
      get() {
        return this.documentNumber
      },
      set(value) {
        this.setDocumentNumber(value)
      },
    },
  },
  methods: {
    ...mapActions(usePersonalStore, [
      'setCompanyName',
      'setRegistrationNumber',
      'setFullName',
      'setIdCode',
      'setEmail',
      'setNumber',
      'setCountryCode',
      'allowConfirmationView',
      'setDocumentType',
      'setDocumentNumber',
    ]),
    forward() {
      this.allowConfirmationView(true)
      this.$router.push('/confirmation')
    },
    goBack() {
      this.$router.push('/')
    },
  },
}
</script>
